import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,
	CCol,
	CCard,CCardHeader,CCardBody,CCardFooter,
	CForm,
	CFormInput,
	CFormSelect,
	CInputGroup,CButton,CInputGroupText,
	//CFormCheck,
	//CImage,
	CLink,
	CTooltip,
	CSpinner,
	CDropdown,CDropdownToggle,CDropdownMenu,CDropdownItem,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { isMobile } from "react-device-detect";
import {
	MyPagination,
	MyDialogform,
	MyPage500,
} from '../components/index'
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { Konfirm } from '../helpers/onConfirm'
import { UFunc } from '../helpers/functions'
import NumberFormat from 'react-number-format';

const pjson 	= require('../../package.json')
const Barang 	= (props) => {
	const {
		setToken,setLoading,showToast,prosesExpired,setSessionaktif,
	} = props; 

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettinguserObj 			= useSelector(state => state.gListUserSetting);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uMaxData					= isMobile ? (uSettinguserObj.jml_mobile || 20) : (uSettinguserObj.jml_laporan || 100);
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uIsHapusallow				= (uTokenObj.userhak==="SUPERADMIN"||uTokenObj.userhak==="PENGELOLA");// ? true : false;
	const uIsEditallow				= (uTokenObj.userhak==="SUPERADMIN"||uTokenObj.userhak==="PENGELOLA"||uTokenObj.userhak==="MANAJER");// ? true : false;
	const [uEfekview,setEfekview] 	= React.useState(false);
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0); 
	
	const uHeaderActionObj  = useSelector(state => state.gInitHeaderAction);
	const uHandelView 		= uHeaderActionObj.isHeaderView || false;
	const uHandelTambah 	= uHeaderActionObj.isHeaderTambah || false;

	//--DATA_TABEL--/
	const uKeywordObj					= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const [uJmlData,setJmlData]			= React.useState(0);
	const [uPageActive,setPageActive]	= React.useState(1);
	const [uJmlHal,setJmlHal]			= React.useState(1);
	const [uDatamainArr,setDatamainArr]	= React.useState([]);
	const [uDatajenisArr,setDatajenisArr]= React.useState([]);
	const [uRowselect,setRowselect]		= React.useState(-1);
	const [uFirstLoad,setFirstLoad]		= React.useState("YA");
	const [uDataselect,setDataselect]	= React.useState({});

	const uDatacabangArr	= JSON.parse(localStorage.getItem("cabanglist")||"[]")
	//--END DATA_TABEL--/

	//--DLG_FORM--/
	const [uIsDlgformshow,setDlgformshow]	= React.useState(false);
	const [uDlgformheader,setDlgformheader]	= React.useState("");
	const [uDlgforminputObj,setDlgforminputObj]= React.useState({});
	//--END DLG_FORM--/

	//--DLG_VIEW--/
	//--END DLG_VIEW--/

	//--DOM_VARS--/
	const uElJmlData		= document.getElementById("idjmldata");
	const fileType 			= "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
	const fileExtension 	= ".xlsx";
	//--END DOM_VARS--/

	//--HANDEL--/
	//const hdlDlgformtoggle = () => { setDlgformshow(false) };
	const hdlKlikTabeledit = (_IDTABEL,_FIELD) => {
		_IDTABEL 	= parseInt(_IDTABEL)||0; if(_IDTABEL <= 0) return;
		_FIELD		= _FIELD||"";

		const vArridx 		= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		const vIdxRow		= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL);
		setRowselect(vIdxRow);

		let vValue 			= 0;
		if(_FIELD === "JENIS")
			vValue = uDatamainArr[vArridx].id_barang_jenis || "0"
		else if(_FIELD === "SKU")
			vValue = uDatamainArr[vArridx].kode_sku||"";

		setDataselect({
			id:uDatamainArr[vArridx].id,
			valueedit:vValue,
			fieldedit:_FIELD,
		})
		setEfekview(!uEfekview);

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			let vElFocus = document.getElementById("inptabelinput");
			vElFocus && vElFocus.focus();
		},250);
	}
	const hdlKlikTabelproses = () => {
		let vValuecheck;
		if(uDataselect.fieldedit === "JENIS") {
			vValuecheck = parseInt(uDataselect.valueedit)||0;
			if(vValuecheck < 0)
				{ showToast("Jenis Barang Tidak Valid !"); return }
		}
		if(uDataselect.fieldedit === "SKU") {
			vValuecheck = (uDataselect.valueedit||"").trim();
			if(vValuecheck.length < 3 && vValuecheck !== "")
				{ showToast("Kode SKU Tidak Valid !"); return }
		}

		console.log("(hdlKlikTabelproses) vValuecheck => "+vValuecheck);
		console.log("(hdlKlikTabelproses) vValuecheck.length => "+vValuecheck.length);
		apiProsesedit();
	}
	const hdlKDownTabelinput = (_EV) => {
		const vTabelID	= parseInt(uDataselect.id)||0; if(vTabelID <= 0) return;
		if(_EV.which === 27) {
			_EV.preventDefault();
			_EV.stopPropagation();

			setDataselect({});setEfekview(!uEfekview);
			return;
		}
		if(_EV.which === 13) { hdlKlikTabelproses(); return; }
	}
	const hdlKlikEdit = (_IDTABEL) => {
		_IDTABEL 	= parseInt(_IDTABEL)||0; if(_IDTABEL <= 0) return;

		const vArridx 		= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		const vCaptionupper = (uDatamainArr[vArridx].nama_barang||"").toUpperCase();
		const vIdxRow		= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL)
		setRowselect(vIdxRow);
		setDataselect({id:uDatamainArr[vArridx].id})

		uDlgforminputObj.nama_barang 	= (uDatamainArr[vArridx].nama_barang||"");
		uDlgforminputObj.kode_sku		= (uDatamainArr[vArridx].kode_sku||"");
		uDlgforminputObj.id_barang_jenis= (uDatamainArr[vArridx].id_barang_jenis||"0");
		uDlgforminputObj.status_barang	= (uDatamainArr[vArridx].status_barang||"UMUM");
		uDlgforminputObj.fee_nurse_1	= (uDatamainArr[vArridx].fee_nurse_1||"0");
		uDlgforminputObj.fee_nurse_2	= (uDatamainArr[vArridx].fee_nurse_2||"0");
		uDlgforminputObj.harga_bahan	= (uDatamainArr[vArridx].harga_bahan||"0");
		uDlgforminputObj.stok_minimal	= (parseInt(uDatamainArr[vArridx].stok_minimal)||0) < 0 
			? 0 : parseInt(uDatamainArr[vArridx].stok_minimal);

		setDlgformheader("Edit Data: "+vCaptionupper);
		setDlgformshow(true);
	}
	const hdlKlikHapus = async(_IDTABEL) => {
		_IDTABEL 	= parseInt(_IDTABEL)||0; if(_IDTABEL <= 0) return;

		const vArridx 		= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		const vIdxRow		= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL)
		const vCaptionupper = (uDatamainArr[vArridx].nama_barang||"").toUpperCase();
		setRowselect(vIdxRow);

		if(await(Konfirm("Hapus Data: <B>"+vCaptionupper+"</B>"+
			"<br/>Apakah Anda Yakin ?"+
			""))) apiProseshapus(_IDTABEL);
	}
	const hdlKlikDlgformsimpan = () => {
		let vElFocus = document.getElementById("inpnamabarang");
		if((uDlgforminputObj.nama_barang||"").trim()==="") {
			vElFocus.focus();
			showToast("Nama Barang Harus Diisi !");return;
		}
		vElFocus = document.getElementById("inpjenisid");
		if((parseInt(uDlgforminputObj.id_barang_jenis)||0) <= 0) {
			vElFocus.focus();
			showToast("Jenis Barang Harus Dipilih !");return;
		}
		vElFocus = document.getElementById("inpstatusbarang");
		if((uDlgforminputObj.status_barang||"").trim()==="") {
			vElFocus.focus();
			showToast("Status Barang Harus Dipilih !");return;
		}
		vElFocus = document.getElementById("inpstokmin");
		if((parseFloat(uDlgforminputObj.stok_minimal)||0) < 0) {
			vElFocus.focus();
			showToast("Stok Minimal Tidak Valid !");return;
		}
		vElFocus = document.getElementById("inpfeenurse1");
		if((parseFloat(uDlgforminputObj.fee_nurse_1)||0) < 0) {
			vElFocus.focus();
			showToast("Fee Nurse I Tidak Valid !");return;
		}
		vElFocus = document.getElementById("inpfeenurse2");
		if((parseFloat(uDlgforminputObj.fee_nurse_2)||0) < 0) {
			vElFocus.focus();
			showToast("Fee Nurse II Tidak Valid !");return;
		}
		vElFocus = document.getElementById("inphargabahan");
		if((parseFloat(uDlgforminputObj.harga_bahan)||0) < 0) {
			vElFocus.focus();
			showToast("Harga Bahan Tidak Valid !");return;
		}

		//console.log("(User - hdlKlikDlgsimpan) vArridx = "+vArridx); 
		apiProsessimpan(uDataselect.id||0);
	}
	const hdlKlikExcel = () => {
		if (uJmlData <= 0) return;

		contentExcel();
	}
	//--END HANDEL--/

	//--INIT--/
	const initFormreset = () => {
		setDataselect({})
		setDlgforminputObj({});
		setEfekview(!uEfekview);
	}
	//--END INIT--/

	//--CONTENT--/
	const contentMain = () => {
		if(uHtml500msg) return ""

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= (vMin);
		const vKeyword 		= UFunc.filterRegex(uKeywordObj.kwd_barang || "");
		const vKeywordcolor = uSettinguserObj.color_keyword || "#D725FF";
		const vReplace 		= new RegExp(vKeyword,"ig");

		const vDataviewArr	= uDatamainArr.slice(vMin,(vMax));

		return (
		<table className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="d-none d-md-table-row text-center align-top classfontsmaller">
			<th width="5%" className="px-0"><small>No</small></th>
			<th className="px-0">
			<small>
			<CRow className="mx-0">
			<CCol md="4" lg="5" className="text-start">{uBahasaObj.caption_namabarang||"Nama Barang"}</CCol>
			<CCol md="1" lg="2" className="">{uBahasaObj.caption_statusbarang||"Status Brg"}</CCol>
			<CCol md="1" className="">{uBahasaObj.caption_stokmin||"Stok Min"}</CCol>
			<CCol md="3" lg="2" className="text-start">{uBahasaObj.word_keterangan||"Keterangan"}</CCol>
			<CCol md="2" lg="1" className="">{uBahasaObj.caption_htotal||"H.Total"} (Rp)</CCol>
			<CCol md="1" className="">&middot;</CCol>
			</CRow>
			</small>
			</th>
			</tr>

			<tr className="d-none p-0 text-center align-top">
				<th width={30} className="p-0"/>
				<th className="p-0"/>
			</tr>
		</thead>

		<tbody>
		{vDataviewArr.map((vItems,vKeys) => {
			const {
				id,nama_barang,harga_bahan,fee_nurse_1,fee_nurse_2,
				kode_sku,id_barang_jenis,nama_barang_jenis,stok_minimal,
				tgl_input,userinput,status_update,status_barang,
			} = vItems;

			vNumber++;
			const vCaptionupper	= (nama_barang||"").toUpperCase();

			const vNamabarang	= vKeyword==="" ? (nama_barang||"") 
				: (nama_barang||"").replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vJenisbarang	= vKeyword==="" ? (nama_barang_jenis||"UNDF") 
				: (nama_barang_jenis||"UNDF").replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vStatusbarang	= vKeyword==="" ? (status_barang||"UNDF") 
				: (status_barang||"UNDF").replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vKodesku	= vKeyword==="" ? (kode_sku||"UNDF") 
				: (kode_sku||"UNDF").replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vUserinput	= vKeyword==="" ? UFunc.Usercaptionfilter((userinput||"UNDF"),1) 
				: (UFunc.Usercaptionfilter((userinput||"UNDF"),1)).replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			
			const vStokminimal	= (parseInt(stok_minimal)||0) < 0 ? 0 : parseInt(stok_minimal);
			const vHargatotal 	= (parseFloat(fee_nurse_1)||0)
				+ (parseFloat(fee_nurse_2)||0)
				+ (parseFloat(harga_bahan)||0)
				+ 0;

			return (
			<tr id={"idtr"+id} key={vKeys} className={"align-top text-end"+(uRowselect===vKeys?" classrowselect":"")}>
			<td className="px-1 pe-0">{vNumber}.</td>

			<td className="px-1">
			<CRow className="mx-0">
			<CCol md="4" className="d-none d-md-block d-lg-none px-1 text-md-start">
				<div className="text-info text-capitalize">{UFunc.renderHTML(vNamabarang)}</div>
				<div>
				{(kode_sku||"") === "" ? (
					<small className="text-muted fst-italic">UNDF SKU</small>
				) : (
					<small className="text-uppercase fw-bolder">{UFunc.renderHTML(vKodesku)}</small>
				)}
				</div>

				<div>
				{(parseInt(id_barang_jenis)||0) <= 0 ? (
					<i className="text-muted">UNDEFINED Jenis</i>
				) : (
					<span className="text-primary">{UFunc.renderHTML(vJenisbarang)}</span>
				)}
				</div>

				<div className="text-danger classfontsmaller">
				<small>[
					{UFunc.WaktuAngka(tgl_input||"")}
					<span className="mx-1">&middot;</span>
					{UFunc.renderHTML(vUserinput)}
				]</small>
				</div>
			</CCol>

			<CCol lg="5" className="d-none d-lg-block px-1 text-md-start text-break">
				{((uDataselect.fieldedit||"")!=="JENIS" || parseInt(uDataselect.id||"0")!==parseInt(id)) ? (
				<>
					<CTooltip content="--Klik Untuk EDIT..">
					<CLink className="classcursorpointer text-primary"
						onClick={()=>hdlKlikTabeledit(id,"JENIS")}>
						{(parseInt(id_barang_jenis)||0) <= 0 ? (
						<i className="text-muted">UNDEFINED Jenis</i>
						) : (
						<>{UFunc.renderHTML(vJenisbarang)}</>
						)}
					</CLink>
					</CTooltip>
				</>
				) : (
				<div className="d-inline-block" style={{maxWidth:"45%",width:250}}>
					{(status_update||false)===true ? (
					<center><CSpinner color="primary" size="sm"/></center>
					) : (
					<>
					<CInputGroup size="sm">
					<CFormSelect size="sm"
						value={uDataselect.valueedit||"0"}
						onKeyDown={(e)=>hdlKDownTabelinput(e)}
						onChange={(e)=>{uDataselect.valueedit=e.target.value;setEfekview(!uEfekview)}}
						id="inptabelinput">
					<option value="0">--PILIH JENIS BARANG--</option>
					{uDatajenisArr.map((vItemjenis,vKeyjenis)=>{
						return (
						<option value={vItemjenis.id} key={vKeyjenis}>
						{(vItemjenis.nama_jenis||"").toUpperCase()}
						</option>
						)
					})}
					</CFormSelect>
					<CButton size="sm"
						color="dark"
						className=""
						onClick={()=>hdlKlikTabelproses()}
						id="btntabelproses">
						<CIcon icon="cilCheckAlt"/>
					</CButton>
					</CInputGroup>
					</>
					)}
				</div>
				)}

				<span className="mx-1">&middot;</span>
				<span className="text-info text-capitalize text-break">{UFunc.renderHTML(vNamabarang)}</span>
				<span className="mx-1">&middot;</span>

				{((uDataselect.fieldedit||"")!=="SKU" || parseInt(uDataselect.id||"0")!==parseInt(id)) ? (
				<>
					<CTooltip content="--Klik Untuk EDIT..">
					<CLink className="classcursorpointer text-black fw-bolder"
						onClick={()=>hdlKlikTabeledit(id,"SKU")}>
						{(kode_sku||"") === "" ? (
						<small className="text-muted fst-italic">UNDF SKU</small>
						) : (
						<small className="text-uppercase">{UFunc.renderHTML(vKodesku)}</small>
						)}
					</CLink>
					</CTooltip>
				</>
				) : (
				<div className="d-inline-block" style={{maxWidth:"30%",width:120}}>
					{(status_update||false)===true ? (
					<><CSpinner color="primary" size="sm"/></>
					) : (
					<>
					<CInputGroup size="sm">
					<CFormInput size="sm"
						maxLength={100}
						className="text-uppercase"
						value={uDataselect.valueedit||""}
						onKeyDown={(e)=>hdlKDownTabelinput(e)}
						onChange={(e)=>{uDataselect.valueedit=e.target.value;setEfekview(!uEfekview)}}
						id="inptabelinput"/>
					<CButton size="sm"
						color="dark"
						className=""
						onClick={()=>hdlKlikTabelproses()}
						id="btntabelproses">
						<CIcon icon="cilCheckAlt"/>
					</CButton>
					</CInputGroup>
					</>
					)}
				</div>
				)}

				<div className="text-danger classfontsmaller">
				<small>[
					{UFunc.WaktuAngka(tgl_input||"")}
					<span className="mx-1">&middot;</span>
					{UFunc.renderHTML(vUserinput)}
				]</small>
				</div>
			</CCol>

			<CCol md="1" lg="2" className="d-none d-md-block px-1 text-md-center classfontsmaller">
				<small>{UFunc.renderHTML(vStatusbarang)}</small>
			</CCol>

			<CCol md="1" className="d-none d-md-block px-1 text-md-center">
				{UFunc.formatAngka(vStokminimal)}
			</CCol>
			
			<CCol md="3" lg="2" className="px-1 d-none d-md-block">
			{((status_barang||"")!=="KLINIK" || (uIsEditallow)) 
			? (
				<>
				<div className="d-flex justify-content-between">
				<span className="classfontsmaller text-start"><small className="">{uBahasaObj.caption_feenurse1||"Fee Nurse 1"}</small></span>
				<small className="">{UFunc.formatAngka(fee_nurse_1)}</small>
				</div>

				<div className="d-flex justify-content-between">
				<span className="classfontsmaller text-start"><small className="">{uBahasaObj.caption_feenurse2||"Fee Nurse 2"}</small></span>
				<small className="w-50">{UFunc.formatAngka(fee_nurse_2)}</small>
				</div>

				<div className="d-flex justify-content-between">
				<span className="classfontsmaller text-start"><small className="">{uBahasaObj.caption_hbahan||"H.Bahan"}</small></span>
				<small className="w-50">{UFunc.formatAngka(harga_bahan)}</small>
				</div>
				</>
				) : (
				<div className="text-start fst-italic text-muted classfontsmaller">
					<small>&middot; Not DISPLAYED &middot;</small>
				</div>
				)}
			</CCol>

			<CCol md="2" lg="1" className="px-1 d-none d-md-block text-success">
				{((status_barang||"")!=="KLINIK" || (uIsEditallow)) ? ( 
				<>{UFunc.formatAngka(vHargatotal)}</>
				) : (
				<div className="text-center fst-italic text-muted classfontsmaller">
					<small>&middot; Not DISPLAYED &middot;</small>
				</div>
				)}
			</CCol>

			<CCol md="1" className="px-0 text-md-center d-none d-md-block">
				{uIsEditallow && (
				<CTooltip content={"--"+(uBahasaObj.caption_editdata||"Edit Data")+": "+vCaptionupper}>
					<CLink onClick={()=>hdlKlikEdit(id)} className="classikontabel classikonedit classcursorpointer"/>
				</CTooltip>
				)}

				{uIsHapusallow && (
				<>
				<CTooltip content={"--"+(uBahasaObj.caption_hapusdata||"Hapus Data")+": "+vCaptionupper}>
					<CLink onClick={()=>hdlKlikHapus(id)} className="classikontabel classikonhapus classcursorpointer"/>
				</CTooltip>
				</>
				)}
			</CCol>

			<CCol xs="12" className="px-1 d-flex justify-content-between d-md-none">
				<div className="text-info text-capitalize">{UFunc.renderHTML(vNamabarang)}</div>

				<CDropdown>
				<CDropdownToggle caret={false} className="p-0" color="transparent">
					<CIcon icon="cilOptions" className="classikonbox" height={25}/>
				</CDropdownToggle>

				<CDropdownMenu>
					{(uIsEditallow) && (
					<CDropdownItem onClick={()=>hdlKlikEdit(id)}>
						<CIcon className="classikonedit me-2 align-middle" height={25}/>
						{uBahasaObj.caption_editdata||"Edit Data"}
					</CDropdownItem>
					)}
							
					{(uIsHapusallow) && (
					<>
					<CDropdownItem onClick={()=>hdlKlikHapus(id)}>
						<CIcon className="align-middle classikonhapus me-2 align-middle" height={25}/>
						{uBahasaObj.caption_hapusdata||"Hapus Data"}
					</CDropdownItem>
					</>
					)}

					{(!uIsEditallow && !uIsHapusallow) && (
					<CDropdownItem>
						<CIcon icon="cilBan" className="me-2 align-middle" height={25}/>NO ACTION
					</CDropdownItem>
					)}
				</CDropdownMenu>
				</CDropdown>
			</CCol>

			<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>

			<CCol xs="4" className="px-1 d-md-none text-start">{uBahasaObj.caption_kodesku||"Kode SKU"}</CCol>
			<CCol xs="8" className="px-1 d-md-none fw-bold">{UFunc.renderHTML(vKodesku)}</CCol>

			<CCol xs="4" className="px-1 d-md-none text-start">{uBahasaObj.caption_jenisbarang||"Jenis Barang"}</CCol>
			<CCol xs="8" className="px-1 d-md-none fst-italic">{UFunc.renderHTML(vJenisbarang)}</CCol>

			<CCol xs="4" className="px-1 d-md-none text-start">{uBahasaObj.caption_inputby||"Inputby"}</CCol>
			<CCol xs="8" className="px-1 text-danger d-md-none">
				<small className="classfontsmaller">[{UFunc.renderHTML(vUserinput)}]</small>
			</CCol>
			
			<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>

			<CCol xs="4" className="px-1 d-md-none text-start">{uBahasaObj.status_barang||"Status Barang"}</CCol>
			<CCol xs="8" className="px-1 d-md-none">{UFunc.renderHTML(vStatusbarang)}</CCol>

			<CCol xs="4" className="px-1 d-md-none text-start fw-bold">{uBahasaObj.caption_stokmin||"Stok Minimal"}</CCol>
			<CCol xs="8" className="px-1 d-md-none fw-bold">{UFunc.formatAngka(vStokminimal)}</CCol>

			{((status_barang||"")!=="KLINIK" || (uIsEditallow)) && (
			<>
			<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>
			<CCol xs="6" className="px-1 d-md-none text-start">{uBahasaObj.caption_feenurse1||"Fee Nurse 1"} (Rp)</CCol>
			<CCol xs="6" className="px-1 d-md-none">{UFunc.formatAngka(fee_nurse_1)}</CCol>
			
			<CCol xs="6" className="px-1 d-md-none text-start">{uBahasaObj.caption_feenurse2||"Fee Nurse 2"} (Rp)</CCol>
			<CCol xs="6" className="px-1 d-md-none">{UFunc.formatAngka(fee_nurse_2)}</CCol>
			
			<CCol xs="6" className="px-1 d-md-none text-start">{uBahasaObj.caption_hbahan||"H.Bahan"} (Rp)</CCol>
			<CCol xs="6" className="px-1 d-md-none">{UFunc.formatAngka(harga_bahan)}</CCol>
			
			<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>

			<CCol xs="6" className="px-1 d-md-none text-start fw-bold">{uBahasaObj.caption_htotal||"H.Total"} (Rp)</CCol>
			<CCol xs="6" className="px-1 d-md-none text-success fw-bold">{UFunc.formatAngka(vHargatotal)}</CCol>
			</>
			)}
			</CRow>
			</td>
			</tr>
			)
		})}
		</tbody>
		</table>
		)
	}
	const contentDlgform = () => {
		if(!uIsDlgformshow) return (<></>)//>

		const vHargatotal = (parseFloat(uDlgforminputObj.fee_nurse_1)||0)
			+ (parseFloat(uDlgforminputObj.fee_nurse_2)||0)
			+ (parseFloat(uDlgforminputObj.harga_bahan)||0)
			+ 0;

		return (
		<CForm className="mx-lg-5">
		<CRow className="my-2 mx-0">
		<CCol md="4" className="text-md-end fw-bolder">{uBahasaObj.caption_namabarang||"Nama Barang"}</CCol>
		<CCol md="8" className="">
			<CFormInput size="sm"
				maxLength={100}
				autoComplete="off"
				className="text-capitalize"
				value={uDlgforminputObj.nama_barang||""}
				onChange={(e)=>{uDlgforminputObj.nama_barang = (e.target.value); setEfekview(!uEfekview);}}
				id="inpnamabarang"/>
		</CCol>
		</CRow>

		<div className="d-md-none classborderbottom my-3"/>

		<CRow className="my-2 mx-0">
		<CCol xs="6" md="4" className="text-md-end">{uBahasaObj.caption_kodesku||"Kode SKU"}</CCol>
		<CCol xs="6" md="5" lg="4" className="">
			<CFormInput size="sm"
				maxLength={50}
				autoComplete="off"
				className="text-uppercase"
				value={uDlgforminputObj.kode_sku||""}
				onChange={(e)=>{uDlgforminputObj.kode_sku = (e.target.value); setEfekview(!uEfekview);}}
				id="inpkodesku"/>
		</CCol>
		</CRow>

		<CRow className="my-2 mx-0">
		<CCol xs="6" md="4" className="text-md-end fw-bolder">{uBahasaObj.caption_jenisbarang||"Jenis Barang"}</CCol>
		<CCol xs="6" md="5" lg="4" className="">
			<CFormSelect size="sm"
				value={uDlgforminputObj.id_barang_jenis||"0"}
				onChange={(e)=>{uDlgforminputObj.id_barang_jenis = (e.target.value); setEfekview(!uEfekview);}}
				id="inpjenisid">
			<option value="0">--PILIH JENIS BARANG--</option>
			{uDatajenisArr.map((vItems,vKeys)=>{
				return (
				<option key={vKeys} value={vItems.id}>{vItems.nama_jenis}</option>
				)
			})}
			</CFormSelect>
		</CCol>
		</CRow>

		<CRow className="my-3 mx-0">
		<CCol md="4"/><CCol md="8" className="classborderbottom"/>
		</CRow>

		<CRow className="my-2 mx-0">
		<CCol xs="6" md="4" className="text-md-end fw-bolder">{uBahasaObj.caption_statusbarang||"Status Barang"}</CCol>
		<CCol xs="6" md="5" lg="4" className="">
			<CFormSelect size="sm"
				value={uDlgforminputObj.status_barang}
				onChange={(e)=>{uDlgforminputObj.status_barang = (e.target.value); setEfekview(!uEfekview);}}
				id="inpstatusbarang">
			<option value="UMUM">Barang UMUM</option>
			<option value="PENUNJANG">Barang PENUNJANG</option>
			<option value="KLINIK">Barang KLINIK</option>
			</CFormSelect>
		</CCol>
		</CRow>

		<CRow className="my-2 mx-0">
		<CCol xs="6" md="4" className="text-md-end">{uBahasaObj.caption_stokmin||"Stok Minimal"}</CCol>
		<CCol xs="6" md="4" lg="3" className="">
			<CInputGroup size="sm">
			<CFormInput size="sm" type="number"
				autoComplete="off"
				min={0}
				className="text-end"
				value={parseInt(uDlgforminputObj.stok_minimal)||0}
				onFocus={(e)=>e.target.select()}
				onChange={(e)=>{uDlgforminputObj.stok_minimal = (e.target.value); setEfekview(!uEfekview);}}
				id="inpstokmin"/>
			<CInputGroupText>PCS</CInputGroupText>
			</CInputGroup>
		</CCol>
		</CRow>

		<CRow className="my-3 mx-0">
		<CCol md="4"/><CCol md="8" className="classborderbottom"/>
		</CRow>

		<CRow className="my-2 mx-0">
		<CCol xs="6" md="4" className="text-md-end">{uBahasaObj.caption_feenurse1||"Fee Nurse I"}</CCol>
		<CCol xs="6" md="5" lg="4" className="">
			<NumberFormat 
				value={uDlgforminputObj.fee_nurse_1||0}
				displayType={'text'} 
				thousandSeparator={"."} 
				decimalSeparator={","}
				onValueChange={(values)=>{uDlgforminputObj.fee_nurse_1 = (values.value); }}
				renderText={values => (
				<CFormInput size="sm"
					value={values}
					className="text-end"
					onFocus={(e)=>e.target.select()}
					onChange={(e)=>{uDlgforminputObj.fee_nurse_1 = (e.target.value); setEfekview(!uEfekview);}}
					id="inpfeenurse1"/>
				)} 
				prefix={!isMobile?"Rp":""}/>
		</CCol>
		</CRow>

		<CRow className="my-2 mx-0">
		<CCol xs="6" md="4" className="text-md-end">{uBahasaObj.caption_feenurse2||"Fee Nurse II"}</CCol>
		<CCol xs="6" md="5" lg="4" className="">
			<NumberFormat 
				value={uDlgforminputObj.fee_nurse_2||0}
				displayType={'text'} 
				thousandSeparator={"."} 
				decimalSeparator={","}
				onValueChange={(values)=>{uDlgforminputObj.fee_nurse_2 = (values.value); }}
				renderText={values => (
				<CFormInput size="sm"
					value={values}
					className="text-end"
					onFocus={(e)=>e.target.select()}
					onChange={(e)=>{uDlgforminputObj.fee_nurse_2 = (e.target.value); setEfekview(!uEfekview);}}
					id="inpfeenurse1"/>
				)} 
				prefix={!isMobile?"Rp":""}/>
		</CCol>
		</CRow>

		<CRow className="my-2 mx-0">
		<CCol xs="6" md="4" className="text-md-end">{uBahasaObj.caption_hargabahan||"Harga Bahan"}</CCol>
		<CCol xs="6" md="5" lg="4" className="">
			<NumberFormat 
				value={uDlgforminputObj.harga_bahan||0}
				displayType={'text'} 
				thousandSeparator={"."} 
				decimalSeparator={","}
				onValueChange={(values)=>{uDlgforminputObj.harga_bahan = (values.value); }}
				renderText={values => (
				<CFormInput size="sm"
					value={values}
					className="text-end"
					onFocus={(e)=>e.target.select()}
					onChange={(e)=>{uDlgforminputObj.harga_bahan = (e.target.value); setEfekview(!uEfekview);}}
					onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
					id="inphargabahan"/>
				)} 
				prefix={'Rp'}/>
		</CCol>
		</CRow>

		<CRow className="my-3 mx-0">
		<CCol md="4"/><CCol md="8" className="classborderbottom"/>
		</CRow>

		<CRow className="my-2 mx-0">
		<CCol xs="6" md="4" className="text-md-end">{uBahasaObj.caption_hargatotal||"Harga Total"}</CCol>
		<CCol xs="6" md="5" lg="4" className="fw-bolder text-end text-success">Rp {UFunc.formatAngka(vHargatotal)}</CCol>
		</CRow>
		</CForm>
		)//>
	}
	const contentExcel = () => {
		const vColspan		= 10;

		let vDatasetsArr 	= [];
		let vRowcount		= 0;
		let vColposwidth	= 50;

		let vTmpObj	= {
			no : "",
			kode_sku: "",
			nama_barang: "",
			nama_barang_jenis: "",
			status_barang: "",
			stok_min: "",
			harga_bahan: "",
			fee_nurse_1: "",
			fee_nurse_2: "",
			total_harga: "",
		};
		vDatasetsArr.push(vTmpObj);
		vRowcount++;

		const vDataArr = uDatamainArr.map((vItems,vKeys)=>{
			const {
				id,nama_barang,harga_bahan,fee_nurse_1,fee_nurse_2,
				kode_sku,id_barang_jenis,nama_barang_jenis,stok_minimal,
				tgl_input,userinput,status_update,status_barang,
			} = vItems;

			vColposwidth = (nama_barang||"").length > vColposwidth 
				? (nama_barang||"").length : vColposwidth; 

			const vStokminimal 	= (parseInt(stok_minimal)||0) < 0 ? 0 : parseInt(stok_minimal);
			const vHargatotal 	= (parseFloat(harga_bahan)||0)
				+ (parseFloat(fee_nurse_1)||0)
				+ (parseFloat(fee_nurse_2)||0)
				+ 0;

			return ({
				no : {v:vKeys+1,t:"n"},
				kode_sku: {v:(kode_sku||"-").toUpperCase(),t:"s",s:{wrapText:true}},
				nama_barang: {v:(nama_barang||"Undf Nama Barang"),t:"s",s:{wrapText:true}},
				nama_barang_jenis: {v:(nama_barang_jenis||"-"),t:"s",s:{wrapText:true}},
				status_barang : {v: (status_barang||"-").toUpperCase(),t:"s",s:{alignment:{horizontal:"center"},font:{bold:true} }},
				stok_min: { v: vStokminimal, t:"n", s:{alignment:{horizontal:"center"},numFmt: "#,##0"} },
				harga_bahan: { v:parseFloat(harga_bahan), t:"n", s:{numFmt: "#,##0"} },
				fee_nurse_1: { v:parseFloat(fee_nurse_1), t:"n", s:{numFmt: "#,##0"} },
				fee_nurse_2: { v:parseFloat(fee_nurse_2), t:"n", s:{numFmt: "#,##0"} },
				total_harga: { v:vHargatotal, t:"n", s:{numFmt: "#,##0"} },
			});
		});
 		vDatasetsArr 	= [...vDatasetsArr,...vDataArr];
		vRowcount 		= vRowcount + vDataArr.length;

		const wsrows	= [{hpt:43}]
		const wscols	= [
			{wpx:40},
			{wpx:70},
			{wch:vColposwidth},
			{wpx:125},
			{wpx:90},
			{wpx:60},
			{wpx:85},
			{wpx:85},
			{wpx:85},
			{wpx:90},
		];
		
		const wsmerge	= [
			{s:{r:0,c:0},e:{r:0,c:vColspan - 1}},
			//{s:{r:vRowcount,c:0},e:{r:vRowcount,c:vColspan - 2}}
		];

		const vTanggalnowDT	= new Date()
		const vNamafile = 
			vTanggalnowDT.getFullYear()+
			UFunc.leadZero(vTanggalnowDT.getMonth()+1)+
			UFunc.leadZero(vTanggalnowDT.getDate())+"_MASTERBARANG"+
		"";
		const vSheetlabel = 
			vTanggalnowDT.getFullYear()+
			UFunc.leadZero(vTanggalnowDT.getMonth()+1)+
			UFunc.leadZero(vTanggalnowDT.getDate())+
			"";

		//--CUSTOM_HEADER--/
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]+
			"\r\nPer "+UFunc.WaktuAngka(UFunc.DbDatetime(vTanggalnowDT))+
		"";
		const vHeaderArr = [
			{v:"No",s:{alignment:{horizontal:"center",vertical:"top"},font:{bold:true}}}, 
			{v:"Kode SKU",s:{alignment:{horizontal:"left",vertical:"top",wrapText:true},font:{bold:true}}}, 
			{v:"Nama Barang",s:{alignment:{horizontal:"left",vertical:"top",wrapText:true},font:{bold:true}}}, 
			{v:"Jenis Barang",s:{alignment:{horizontal:"left",vertical:"top",wrapText:true},font:{bold:true}}}, 
			{v:"Status",s:{alignment:{horizontal:"center",vertical:"top",wrapText:true},font:{bold:true}}}, 
			{v:"Stok Min",s:{alignment:{horizontal:"center",vertical:"top",wrapText:true},font:{bold:true}}}, 
			{v:"H.Bahan\r\n(Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText:true},font:{bold:true}}}, 
			{v:"Fee Nurse 1\r\n(Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText:true},font:{bold:true}}}, 
			{v:"Fee Nurse 2\r\n(Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText:true},font:{bold:true}}}, 
			{v:"Total Harga\r\n(Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText:true},font:{bold:true}}}, 
		];

		const ws 		= XLSX.utils.json_to_sheet(vDatasetsArr);

		XLSX.utils.sheet_add_aoa(ws, [[{v:vJudullaporan,t:"s",s:{
			alignment:{horizontal:"center",vertical:"center",wrapText: true},
			font:{bold:true} 
		}}]], { origin: "A1" });
		XLSX.utils.sheet_add_aoa(ws, [vHeaderArr], { origin: "A2" });
		//--END CUSTOM_HEADER--*/

		ws['!rows'] 	= wsrows;
		ws['!cols'] 	= wscols;
		ws["!merges"] 	= wsmerge;

		const wb 		= { Sheets: { [vSheetlabel]: ws }, SheetNames: [vSheetlabel] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
		const data 		= new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, vNamafile + fileExtension);
	}
	//--END CONTENT--/

	//--REST_API--/
	const apiLoaddata = () => {
		setHtml500msg();
		setDatamainArr([]);
		setDataselect(0);
		setRowselect(-1);
		setPageActive(1);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTmpObj		= []
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setLoading(false);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vKeyword 	= uKeywordObj.kwd_barang || "";
		const vDATAS	= JSON.stringify({
			send_firstload : uFirstLoad,
			send_keyword : vKeyword,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_barang/ld_data";

		setTimeelapse(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.tampil) {
				//console.log("(Barang - apiLoaddata) output_string.datajenisbarang : "+output_string.datajenisbarang);
				setDatamainArr(JSON.parse(output_string.dataobject||"[]"));
				setDatajenisArr(JSON.parse(output_string.datajenisbarang ||
					JSON.stringify(uDatajenisArr)));
				if(uFirstLoad==="YA") { setFirstLoad("TIDAK"); }

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeelapse(vTimeDiff);
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Barang - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg(vMsg);
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Barang - apiLoaddata) catch-error : "+error);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiProsesedit = () => {
		const vTabelID 	= parseInt(uDataselect.id)||0;
		const vField	= uDataselect.fieldedit||"";
		const vValue	= uDataselect.valueedit||"";
		const vArridx 	= UFunc.getObjectIndeks(uDatamainArr,vTabelID);

		if(uDataselect.fieldedit === "JENIS") {
			if((parseInt(vValue)||0) === parseInt(uDatamainArr[vArridx].id_barang_jenis)) {
				setDataselect({});
				return;
			}
		}
		if(uDataselect.fieldedit === "SKU") {
			if(vValue.toUpperCase() === (uDatamainArr[vArridx].kode_sku||"").toUpperCase()) {
				setDataselect({});
				return;
			}
		}
		uDatamainArr[vArridx].status_update = true;
		setEfekview(!uEfekview);

		/*let vTimeout 	= setTimeout(()=>{
			clearTimeout(vTimeout);
		},2000); return
		//-*/

		const vDATAS	= JSON.stringify({
			send_tabelid : uDataselect.id || "0",
			send_datajson : JSON.stringify(uDataselect),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_barang/pr_edit";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			uDatamainArr[vArridx].status_update 	= false;
			setSessionaktif(true);
			if(output_string.sukses) {
				if(uDataselect.fieldedit === "JENIS") {
					uDatamainArr[vArridx].id_barang_jenis 	= vValue;

					const vArrjenis = UFunc.getObjectIndeks(uDatajenisArr,vValue);
					uDatamainArr[vArridx].nama_barang_jenis = vArrjenis >= 0
						? uDatajenisArr[vArrjenis].nama_jenis : null;
				} else if(uDataselect.fieldedit === "SKU") {
					uDatamainArr[vArridx].kode_sku 	= vValue.toUpperCase();
				}

				setDataselect({});
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Barang - apiProsesedit) output_string.errors : "+output_string.errors);
				const vMsg	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setDlgformshow(false); setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			uDatamainArr[vArridx].status_update 	= false;
			console.log("(Barang - apiProsesedit) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProsessimpan = (_IDTABEL) => {
		_IDTABEL 		= parseInt(_IDTABEL)||0;

		const vArrjenis	= UFunc.getObjectIndeks(uDatajenisArr,uDlgforminputObj.id_barang_jenis);
		const vArridx 	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		const vBtnsimpan= document.getElementById("btnDialogSimpan");
		vBtnsimpan && (vBtnsimpan.disabled = true)
		setLoading(true)

		/*//--TESTING_FRONTEND--/
		console.log("(User - apiProsessimpan) LEWAT "); 
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tabelid : _IDTABEL,
			send_datajson : JSON.stringify(uDlgforminputObj),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_barang/pr_simpan";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			vBtnsimpan && (vBtnsimpan.disabled = false)
			if(output_string.sukses) {
				if(_IDTABEL <= 0) {
					const vTmpObj = {
						id: output_string.tabelid||255,
						tgl_input: "",
						userinput: uTokenObj.usercaption,
						nama_barang:uDlgforminputObj.nama_barang,
						kode_sku:uDlgforminputObj.kode_sku,
						id_barang_jenis:uDlgforminputObj.id_barang_jenis,
						status_barang:uDlgforminputObj.status_barang,
						stok_minimal:uDlgforminputObj.stok_minimal,
						fee_nurse_1:uDlgforminputObj.fee_nurse_1,
						fee_nurse_2:uDlgforminputObj.fee_nurse_2,
						harga_bahan:uDlgforminputObj.harga_bahan,
						nama_barang_jenis:vArrjenis>=0 ? uDatajenisArr[vArrjenis].nama_jenis : null,
					}
					setDatamainArr([vTmpObj,...uDatamainArr]);

					initFormreset();
					setPageActive(1);
					setRowselect(-1);
					showToast((uBahasaObj.pesan_sukses || "Data Berhasil Disimpan.."),"SUKSES");

					const vElFocus = document.getElementById("inpnamabarang");
					vElFocus && vElFocus.focus();
				} else {
					uDatamainArr[vArridx].nama_barang 	= uDlgforminputObj.nama_barang;
					uDatamainArr[vArridx].kode_sku 		= uDlgforminputObj.kode_sku;
					uDatamainArr[vArridx].id_barang_jenis= uDlgforminputObj.id_barang_jenis;
					uDatamainArr[vArridx].status_barang = uDlgforminputObj.status_barang;
					uDatamainArr[vArridx].stok_minimal 	= uDlgforminputObj.stok_minimal;
					uDatamainArr[vArridx].fee_nurse_1 	= uDlgforminputObj.fee_nurse_1;
					uDatamainArr[vArridx].fee_nurse_2 	= uDlgforminputObj.fee_nurse_2;
					uDatamainArr[vArridx].harga_bahan 	= uDlgforminputObj.harga_bahan;
					uDatamainArr[vArridx].nama_barang_jenis	= vArrjenis >= 0 
						? uDatajenisArr[vArrjenis].nama_jenis : null;

					setDlgformshow(false);
				}
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Barang - apiProsessimpan) output_string.errors : "+output_string.errors);
				const vMsg	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setDlgformshow(false); setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			vBtnsimpan && (vBtnsimpan.disabled = false)
			setLoading(false);
			console.log("(Barang - apiProsessimpan) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProseshapus = (_IDTABEL) => {
		_IDTABEL 		= parseInt(_IDTABEL)||0; if(_IDTABEL <= 0) return;
		const vArridx 	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		setLoading(true)

		/*//--TESTING_FRONTEND--/
		console.log("(User - apiProsessimpan) LEWAT "); 
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tabelid : _IDTABEL,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_barang/pr_hapus";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.sukses) {
				uDatamainArr.splice(vArridx,1);
				setRowselect(-1);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Barang - apiProseshapus) output_string.errors : "+output_string.errors);
				const vMsg	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setDlgformshow(false); setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Barang - apiProseshapus) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//--END REST_API--/

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});
    	
    	apiLoaddata();

    	return () => {
    		setFirstLoad("YA");
    		setDatamainArr([]);
    		setDatajenisArr([]);
    		setDlgformshow(false);
    	}
	},[])
	React.useEffect(()=>{
		//console.log("(Barang-[uHandelView]) uHandelView = "+uHandelView)
		if(!uHandelView) return;

		uHeaderActionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		apiLoaddata();
	},[uHandelView])
	React.useEffect(()=>{
		//console.log("(Barang-[uHandelTambah]) uHandelTambah = "+uHandelTambah)
		if(!uHandelTambah) return;

		uHeaderActionObj.isHeaderTambah = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});
		if(uHtml500msg) return;

		setDlgformheader((uBahasaObj.word_tambah||"Tambah")+" "+uBahasaObj["menus_"+uActiveroute.toLowerCase()]);
		setDlgformshow(true);
	},[uHandelTambah])
	React.useEffect(()=>{
		setJmlData(uDatamainArr.length);
		if(uDatamainArr.length <= 0) return;
	},[uDatamainArr,uDatamainArr.length])
	React.useEffect(()=>{
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);//-*/
		setPageActive(uPageActive<=0?1:uPageActive);

		/*const vKeyword = uKeywordObj.kwd_barang || "";
		if(vKeyword.length <= 2) {
			uElJmlData && (uElJmlData.innerHTML = "&#8734;");
			return;
		}//-*/
		uElJmlData && (uElJmlData.innerHTML = UFunc.formatAngka(uJmlData));
	},[uJmlData])
	React.useEffect(()=>{ setRowselect(-1); },[uPageActive])//-->Unselect_ROW
	React.useEffect(()=>{
		if(!uIsDlgformshow) { initFormreset(); return; }

		if(uDlgforminputObj.stok_minimal === undefined)
			uDlgforminputObj.stok_minimal = 0;
		if(uDlgforminputObj.status_barang === undefined)
			uDlgforminputObj.status_barang = "UMUM";

		//console.log("("+cComponentName+"[uIsDlgformshow]) uIsDlgformshow 1: "+uIsDlgformshow);
		let vTimeout = setTimeout(function(e){
			clearTimeout(vTimeout);
			const vElFocus = document.getElementById("inpnamabarang");
			if(!isMobile) vElFocus && vElFocus.focus();
		},350);
	},[uIsDlgformshow])//-*/
	//React.useEffect(()=>{ },[uDlgforminputObj])

	if(UFunc.isEmpty(uTokenObj)) {
		setLoading(true); prosesExpired(); return;
	}
	if(uHtml500msg)  return (
		<MyPage500 content={uHtml500msg}/>
	)

	return (
		<>
		<CCard className="classcardbg">
		<CCardHeader className="d-flex justify-content-between align-items-center">
		<b>{uBahasaObj.caption_listdata||"List Data"}</b>
		
		<div>
			{uJmlData > 0 && (
			<>
				<CLink onClick={()=>hdlKlikExcel()} className="classcursorpointer">
				<CIcon className="classikontabel classikonexcel" height={27}/>
				</CLink>

				<small className="me-2">&middot;</small>
			</>
			)}

			<small className="me-2 d-md-none">
				(<b className="text-primary">{UFunc.formatAngka(uJmlData)}</b>)
				<span className="ms-2">&middot;</span>
			</small>

			<span className="classfontsmaller">
				<small className="text-muted">{UFunc.formatAngka(uTimeelapse)}ms</small>
			</span>
		</div>
		</CCardHeader>

		<CCardBody className="px-0">{contentMain()}</CCardBody>

		{(uJmlData > uMaxData) && (
		<CCardFooter>
			<MyPagination 
				activePage={uPageActive}
				pages={uJmlHal}
				onActivePageChange={(i)=>setPageActive(i)}
				align="start"/>
		</CCardFooter>
		)}
		</CCard>

		<MyDialogform
			options={{size:"lg",centered:true}}
			onSimpan={()=>hdlKlikDlgformsimpan()}
			show={uIsDlgformshow} 
			dialogHeader={uDlgformheader}
			toggle={()=>setDlgformshow(false)}
			renderContent={contentDlgform()}/>
		</>
	)//>
}	

export default Barang